<script>
export default {
  name: 'GanttHeader',
  props: {
    x: Number,
    y: Number,
    w: Number,
    h: Number,
    title: [Number, String],
  },
};
</script>

<template lang="pug">
    g
      rect(:x="x + 4" :y="y" :height="h" :width="w - 8" fill="white" :rx="4" :ry="4")
      text(:x="x + 4" :y="y" :dx="(w - 8) / 2" :dy="h / 2") {{ title }}
</template>

<style scoped>
  text {
    font-weight: 400;
    font-size: 11px;
    line-height: 14px;
    color: #1E3147;
    dominant-baseline: central;
    text-anchor: middle;
  }
</style>
